import { useSelector } from "react-redux";
import styles from "../Components/ProductList.module.css";

const OrderSummary = ({item}) => {
  let productQuantity = useSelector(store => store.bag.bagListQuantity);    
  let productQty = productQuantity.find(el => el.id === item.id);
    return <>
        <div className="card mb-3">
          <div className="row g-0">
            <div className="col-md-4">              
              <p id={`${styles.rcorners1}`}><img
                      src={`${global.config.live_url}${item.product_image}`}
                      className="card-img-top"
                      alt="..." width="200px" height="150px"
                    /></p>
            </div>
            <div className="col-md-6">
              <div className="card-body">        
                
                <p className="card-text">
                  <small className="text-muted">{item.product_name}</small>
                </p>
                <p className="card-text">
                  <small className="text-muted">{item.product_weight} {item.product_unit}</small>
                </p>
                <p className="card-text">
                  <small className="text-muted">
                    &#x20B9;{" "}
                      {item.product_offer > 0
                        ? Math.round(
                            (item.product_price * productQty.quantity) -
                              ((item.product_price * productQty.quantity) * item.product_offer) / 100
                          )
                        : ""}{" "}
                      {item.product_offer > 0 ? (
                        <span className={styles.productPriceLineThrough}>
                          &#x20B9;{item.product_price * productQty.quantity}
                        </span>
                      ) : (
                        item.product_price * productQty.quantity
                      )}{" "}
                  </small>
                </p>
                <p className="card-text">
                  <small className="text-muted">
                    Quantity: {productQty.quantity}
                  </small>
                </p>
              </div>
            </div>
            
          </div>
    </div>
    </>
}
export default OrderSummary;